/**
 * App configuration
 */
export const appConfig = {
  name: 'Paneon Pets',
  version: '0.1.0',
  description: 'Verwalte die Ernährung deiner Haustiere',

  // API
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',

  // Features
  features: {
    pushNotifications: true,
    offlineMode: true,
    darkMode: true,
  },

  // Default settings
  defaults: {
    language: 'de',
    weightUnit: 'kg' as const,
    themeId: 'ocean',
  },

  // Grid settings
  grid: {
    columns: 12,
    cellHeight: 80,
    margin: 8,
  },
};

/**
 * Pet species configuration
 */
export const petSpecies = [
  { id: 'dog', name: 'Hund', icon: '🐕' },
  { id: 'cat', name: 'Katze', icon: '🐈' },
  { id: 'bird', name: 'Vogel', icon: '🐦' },
  { id: 'fish', name: 'Fisch', icon: '🐟' },
  { id: 'rabbit', name: 'Hase', icon: '🐰' },
  { id: 'hamster', name: 'Hamster', icon: '🐹' },
  { id: 'other', name: 'Andere', icon: '🐾' },
] as const;

/**
 * Feeding types
 */
export const feedingTypes = [
  { id: 'breakfast', name: 'Frühstück', icon: '🌅' },
  { id: 'lunch', name: 'Mittagessen', icon: '☀️' },
  { id: 'dinner', name: 'Abendessen', icon: '🌙' },
  { id: 'snack', name: 'Snack', icon: '🍖' },
] as const;

/**
 * Food types
 */
export const foodTypes = [
  { id: 'dry', name: 'Trockenfutter' },
  { id: 'wet', name: 'Nassfutter' },
  { id: 'raw', name: 'Rohfutter (BARF)' },
  { id: 'homemade', name: 'Selbstgekocht' },
  { id: 'treat', name: 'Leckerli' },
] as const;
